import React from 'react';
import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Hiring from './Hiring.js';
import * as page from './enum.js';

class Offerings extends React.Component{
    render(){
        return (
            <div id="Modal_Content_Color">
                    <p>We are a growing organization. We provide recruitment services on PAN India level in all the domains i.e.,
                    IT Sector, BPO, KPO, Airlines, hospitality, real state and many more. To clients we offer a convenient way of
                    recruitment process at their desired time and conditions i.e., we extract resumes from various portals and send
                    it to the client and as the client shortlists the resumes and gives slots we schedule candidates accordingly as
                    per their convenience.For candidates, we are offering the convenience of their job change needs to fulfill take
                    over the charge of placing candidates as per their requirements.</p>
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col" id="Candidate">
                                    <h4 class="mt-4">For Candidates</h4>
                                    <div class="mt-3">1. Searching Companies</div>
                                    <div class="mt-2">2. Scheduling Interviews</div>
                                    <div class="mt-2">3. Sharing Feedback with Client</div>
                                    <div class="mt-2">4. Salary Negotiation</div>
                                    <div class="mt-2">5. Notice Period Negotiation</div>
                                    <div class="mt-2">6. Offer Releasing</div>
                                    <div class="mt-2">7. Joining Formalities</div>
                                    <div class="mt-2">8. Further Assistance If Needed</div>
                            </div>
                            <div class="col">
                                    <h4 class="mt-4">For Clients</h4>
                                    <div class="mt-3">1. Searching Companies</div>
                                    <div class="mt-2">2. Scheduling Interviews</div>
                                    <div class="mt-2">3. Following Up with Candidates</div>
                                    <div class="mt-2">4. Salary Negotiation</div>
                                    <div class="mt-2">5. Notice Period Negotiation</div>
                                    <div class="mt-2">6. Further Assistance If Needed</div>
                            </div>
                         </div>
                    </div>
                </div>
        );
    }
}

export default Offerings;